import { render, staticRenderFns } from "./relatedCarousel.vue?vue&type=template&id=e5c87e7c&scoped=true&"
import script from "./relatedCarousel.vue?vue&type=script&lang=js&"
export * from "./relatedCarousel.vue?vue&type=script&lang=js&"
import style0 from "./relatedCarousel.vue?vue&type=style&index=0&id=e5c87e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c87e7c",
  null
  
)

export default component.exports